import { render, staticRenderFns } from "./WidgetAdvancedDataCreation.vue?vue&type=template&id=2bd1b83e"
import script from "./WidgetAdvancedDataCreation.vue?vue&type=script&lang=js"
export * from "./WidgetAdvancedDataCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports